import { useCallback, useEffect, useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Button, TextField } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import Upload from "components/shared/Upload";
import BackButton from "components/shared/BackButton";
import {
  StyledStack,
  StyledTitle,
  StyledMenuItem,
  ButtonContainer,
} from "./Add.style";
import DrawerCM from "components/shared/Drawer";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import Toast from "helper/toast";
import ProgressBarCM from "components/shared/ProgressBar";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { articleSchema, validateImg } from "validations";
import { addArticleRequest, getCategoryNewsRequest } from "api/requests";
import Editor, { buttonList } from "suneditor-react";
import ReactHookFormSelect from "components/shared/ReactHookFormSelect";
import "suneditor/dist/css/suneditor.min.css";
let initialPage = 1;
export default function AddNews() {
  const navigate = useNavigate();
  const [frame, setFrame] = useState({ data: [], count: 0 });
  const [page, setPage] = useState(initialPage);
  const { request, loading, isUploading, setUploadProgress, uploadProgress } =
    useHttp(false);
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(articleSchema),
  });
  // const [image, setImage] = useState({ url: null, isChanged: false });
  const [file, setFile] = useState("");

  ////// editor ////////
  const [content, setContent] = useState("");
  const handleChange = (content) => {
    setContent(content);
  };

  const onSubmit = async (data) => {
    const res = await request({
      url: () =>
        addArticleRequest({ ...data, content }, (progress) =>
          setUploadProgress(progress)
        ),
      // isFile: true,
    });

    if (res) {
      Toast({ type: "success", title: "ثبت مقاله" });
      reset({
        title: "",
        text: "",
        file: "",
        article_category_id: "",
      });
      // setImage({ url: null, isChanged: false });
      navigate("/news");
    }
  };

  const handelTempChange = (e) => {
    setValue("text", e);
  };

  const getFrame = useCallback(async () => {
    const res = await request({
      url: getCategoryNewsRequest,
      values: { skip: (page - 1) * 50, limit: 50 },
    });

    if (res) {
      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
      }));

      setFrame({ data: transformedData, count: res.count });
    }
  }, [request]);

  useEffect(() => {
    getFrame();
  }, [page, getFrame]);

  // const handleChangeImage = (val) => {
  //   validateImg(val);
  //   setImage({ url: val, isChanged: true });
  // };

  return (
    <DrawerCM title="ثبت مقاله">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container my={2}>
          <Grid item mt={3} xs={12}>
            <BackButton />
          </Grid>
          <StyledStack>
            <StyledTitle>ثبت مقاله جدید</StyledTitle>
            <Grid container>
              <Grid item md={12} xs={12} p={1.5}>
                <TextField
                  label="عنوان"
                  variant="outlined"
                  fullWidth
                  id="title"
                  {...register("title")}
                  error={Boolean(errors.title)}
                  helpertext={errors.title?.message}
                />
              </Grid>
              <Grid item md={6} xs={12} p={1.5}>
                <ReactHookFormSelect
                  id="article_category_id"
                  label="سردسته"
                  control={control}
                  defaultValue=""
                  title="سردسته"
                  onChange={handelTempChange}
                >
                  {frame.data.map((row, index) => (
                    <StyledMenuItem value={row.id} key={"option" + index}>
                      {row.title}
                    </StyledMenuItem>
                  ))}
                </ReactHookFormSelect>
              </Grid>
              <Grid item md={6} xs={12} p={1.5}>
                <TextField
                  type="file"
                  variant="outlined"
                  fullWidth
                  id={file}
                  {...register("file")}
                  error={Boolean(errors.file)}
                  helpertext={errors.file?.message}
                  onChange={(e) => setFile(e.target.files[0].name)}
                />
              </Grid>

              <Grid item md={12} xs={12} p={1.2}>
                {/* <TextField
                  label="متن"
                  variant="outlined"
                  multiline
                  rows={5.7}
                  fullWidth
                  id="text"
                  {...register("text")}
                  error={Boolean(errors.text)}
                  helpertext={errors.text?.message}
                /> */}
                <Editor
                  enableToolbar={true}
                  // onChange={(text) => setContent(text)}
                  onChange={handleChange}
                  setDefaultStyle="font-family: IranSans; height: 40vh;"
                  setOptions={{
                    buttonList: buttonList.complex,
                    font: [
                      "IranSans",
                      "IranSansBold",
                      "Arial",
                      "Impact",
                      "Tahoma",
                    ],
                  }}
                />
              </Grid>

              <Grid item md={6} xs={12} p={1.5}>
                {/* <Upload
                  isLocal={image.isChanged}
                  file={image.url}
                  refillable
                  type="add"
                  onChange={handleChangeImage}
                  width={"100%"}
                  height={"100%"}
                /> */}
              </Grid>

              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ثبت
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
